import React, { useEffect, useState } from 'react';
import './style.css';
import { useNavigate, useParams } from "react-router-dom";
import categoriesIcon from '../../../assets/icons/category.svg';
import ProfileIntiationLablesContainer from '../../../components/DashboardComponents/ProfileIntiationLablesContainer';
import PostRequest from '../../../service/PostRequest';
import FormSeperator from '../../../components/LoginFormComponents/FormSeperator';
import { Button } from 'primereact/button';
import languageOptions from '../../../consts/LanguageOptions';
import InputSelectionDropdown from '../../../components/Widgets/Inputs/InputSelectionDropdown';
import InputFieldText from '../../../components/Widgets/Inputs/InputFieldText';

const AddBranchesPage = ({ setActivePath }) => {
    const navigate = useNavigate();
    const { storeId } = useParams(); // Assuming 'data' is the parameter name

    const [formState, setFormState] = useState({
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        city: "",
        country: "United Kingdom",
        county: "",
        postcode: "",
        contact: "",
        email: "",
        nativeLanguage: "English",
    });

    const [errors, setErrors] = useState({});

    const countryOptions = [
        { value: 'United Kingdom', label: 'United Kingdom' },
        { value: 'India', label: 'India' },
        { value: 'Algeria', label: 'Algeria' },
        { value: 'American Samoa', label: 'American Samoa' },
        { value: 'Andorra', label: 'Andorra' },
        { value: 'Angola', label: 'Angola' },
        { value: 'Anguilla', label: 'Anguilla' },
        { value: 'Antarctica', label: 'Antarctica' },
        { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Armenia', label: 'Armenia' },
        { value: 'Aruba', label: 'Aruba' },
        { value: 'Australia', label: 'Australia' },
        { value: 'Austria', label: 'Austria' },
        { value: 'Azerbaijan', label: 'Azerbaijan' },
        { value: 'Bahamas', label: 'Bahamas' },
        { value: 'Bahrain', label: 'Bahrain' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'Barbados', label: 'Barbados' },
        { value: 'Belarus', label: 'Belarus' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Belize', label: 'Belize' },
        { value: 'Benin', label: 'Benin' },
        { value: 'Bermuda', label: 'Bermuda' },
        { value: 'Bhutan', label: 'Bhutan' },
        { value: 'Bolivia', label: 'Bolivia' },
        { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
        { value: 'Botswana', label: 'Botswana' },
        { value: 'Bouvet Island', label: 'Bouvet Island' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'British Indian Ocean Territory', label: 'British Indian Ocean Territory' },
        { value: 'Brunei Darussalam', label: 'Brunei Darussalam' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Burkina Faso', label: 'Burkina Faso' },
        { value: 'Burundi', label: 'Burundi' },
        { value: 'Cambodia', label: 'Cambodia' },
        { value: 'Cameroon', label: 'Cameroon' },
        { value: 'Canada', label: 'Canada' },
        { value: 'Cape Verde', label: 'Cape Verde' },
        { value: 'Cayman Islands', label: 'Cayman Islands' },
        { value: 'Central African Republic', label: 'Central African Republic' },
        { value: 'Chad', label: 'Chad' },
        { value: 'Chile', label: 'Chile' },
        { value: 'China', label: 'China' },
        { value: 'Christmas Island', label: 'Christmas Island' },
        { value: 'Cocos (Keeling) Islands', label: 'Cocos (Keeling) Islands' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Comoros', label: 'Comoros' },
        { value: 'Congo', label: 'Congo' },
        { value: 'Congo, the Democratic Republic of the', label: 'Congo, the Democratic Republic of the' },
        { value: 'Cook Islands', label: 'Cook Islands' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Croatia', label: 'Croatia' },
        { value: 'Cuba', label: 'Cuba' },
        { value: 'Cyprus', label: 'Cyprus' },
        { value: 'Czech Republic', label: 'Czech Republic' },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Djibouti', label: 'Djibouti' },
        { value: 'Dominica', label: 'Dominica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'El Salvador', label: 'El Salvador' },
        { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
        { value: 'Eritrea', label: 'Eritrea' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Ethiopia', label: 'Ethiopia' },
        { value: 'Falkland Islands (Malvinas)', label: 'Falkland Islands (Malvinas)' },
        { value: 'Faroe Islands', label: 'Faroe Islands' },
        { value: 'Fiji', label: 'Fiji' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'French Guiana', label: 'French Guiana' },
    ]

    const handleInputChange = (field, value) => {
        setFormState((prevState) => ({ ...prevState, [field]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
    };

    useEffect(() => {
        setActivePath("Dashboard");
    }, [setActivePath]);

    const validateForm = () => {
        let tempErrors = {};
        if (!formState.addressLine1) tempErrors.addressLine1 = "Address Line 1 is required";
        if (!formState.addressLine2) tempErrors.addressLine2 = "Address Line 2 is required";
        if (!formState.addressLine3) tempErrors.addressLine3 = "Address Line 3 is required";
        if (!formState.city) tempErrors.city = "City is required";
        if (!formState.county) tempErrors.county = "County is required";
        if (!formState.postcode) tempErrors.postcode = "Postcode is required";
        if (!formState.contact) tempErrors.contact = "Contact is required";
        if (!formState.email) tempErrors.email = "Email is required";
        if (!formState.nativeLanguage) tempErrors.nativeLanguage = "Native Language is required";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const addCategory = async () => {
        if (validateForm()) {
            const data = { ...formState };
            console.log("the registered data is", data);

            try {
                const response = await PostRequest(`v1/store-management-service/create/store/${storeId}/add/branch`, data, true);
                console.log(response);
                if (response === undefined) {
                    console.log("Branch Added failed");
                } else {
                    console.log("Branch added");
                    navigate("/store/complete/profile");
                }
            } catch (error) {
                console.error("Branch Added failed:", error);
            }
        }
    };

    return (
        <div className="outlet-container">
            <div className="background-white">
                <div className="background-white-sub-container">
                    <br />
                    <ProfileIntiationLablesContainer title="Add Branches" description="Add Branch details" status={true} icon={categoriesIcon} iconBackgroundColor="#CE7B69" />
                    <FormSeperator content="Location Details" />
                    <InputFieldText value={formState.addressLine1} onChange={(e) => handleInputChange('addressLine1', e.target.value)} label="Enter Address Line 1" errorMessage={errors.addressLine1}/>
                    <InputFieldText value={formState.addressLine2} onChange={(e) => handleInputChange('addressLine2', e.target.value)} label="Enter Address Line 2" errorMessage={errors.addressLine2}/>
                    <InputFieldText value={formState.addressLine3} onChange={(e) => handleInputChange('addressLine3', e.target.value)} label="Enter Address Line 3" errorMessage={errors.addressLine3}/>
                    <InputFieldText value={formState.city} onChange={(e) => handleInputChange('city', e.target.value)} label="Enter City name" errorMessage={errors.city}/>
                    <InputFieldText value={formState.county} onChange={(e) => handleInputChange('county', e.target.value)} label="Enter County" errorMessage={errors.county}/>
                    </div>

                    <div className='flex-input-container'>

                    <InputSelectionDropdown 
                            value={formState.country}
                            onChange={(e) => handleInputChange('country', e.target.value)}
                            options={countryOptions}
                            optionLabel="label" 
                            placeholder="Choose Country" 
                    />
                    

                    <InputFieldText value={formState.postcode} onChange={(e) => handleInputChange('postcode', e.target.value)} label="Enter Postcode" errorMessage={errors.postcode}/>

                    </div>

                    <FormSeperator content="Contact Person Details" />
                    <InputFieldText value={formState.contact} onChange={(e) => handleInputChange('contact', e.target.value)} label="Enter contact" errorMessage={errors.contact}/>
                    <InputFieldText value={formState.email} onChange={(e) => handleInputChange('email', e.target.value)} label="Enter Email" errorMessage={errors.email}/>
                    <FormSeperator content="Branch Properties" />

                    <InputSelectionDropdown 
                            value={formState.nativeLanguage}
                            onChange={(e) => handleInputChange('nativeLanguage', e.target.value)}
                            options={languageOptions}
                            optionLabel="label" 
                            placeholder="Choose Language" 
                    />
                    
                    <br />
                    <div className="centralised-text">
                        <Button onClick={addCategory} variant="contained" label="Add Branch"/>
                    </div>
                </div>
            
        </div>
    );
};

export default AddBranchesPage;
